import React from "react";
import { Modal, Button, Row, Col, Badge } from "react-bootstrap";
import Spinner from "../spinner/Spinner";

const EnrichmentConfirmationModal = ({
  show,
  onHide,
  contacts,
  totalCost,
  profile,
  enrichLoading,
  onConfirm,
  onBuyCredits
}) => {
  const hasActiveSubscription = profile?.subscriptions?.some(
    (sub) => sub?.status === "active"
  );
  const hasInsufficientCredits =
    !hasActiveSubscription && (profile?.deals_wallet_credits || 0) < totalCost;

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Confirm Contact Enrichment</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-4">
          <h5 className="mb-4">Enrichment Summary</h5>
          <Row>
            <Col md={hasActiveSubscription ? 12 : 6}>
              <div className="p-4 border rounded bg-light h-100">
                <h6 className="text-primary mb-3">
                  <i className="fas fa-users me-2"></i>Contact Details
                </h6>
                <div className="mb-2">
                  <strong>Total Contacts:</strong> 
                  <Badge bg="info" className="ms-2">{contacts.count}</Badge>
                </div>
                {!hasActiveSubscription && (
                  <>
                    <div className="mb-2">
                      <strong>Cost per Contact:</strong> 
                      <span className="ms-2">2 credits</span>
                    </div>
                    <div className="mb-0">
                      <strong>Total Cost:</strong> 
                      <Badge bg="warning" className="fs-6 ms-2">{totalCost} credits</Badge>
                    </div>
                  </>
                )}
                {hasActiveSubscription && (
                  <div className="text-success mb-0">
                    <small>
                      <i className="fas fa-crown me-1"></i>
                      Unlimited enrichment included with your subscription
                    </small>
                  </div>
                )}
              </div>
            </Col>
            {!hasActiveSubscription && (
              <Col md={6}>
                <div className="p-4 border rounded bg-light h-100">
                  <h6 className="text-success mb-3">
                    <i className="fas fa-wallet me-2"></i>Your Credits
                  </h6>
                  <div className="mb-2">
                    <strong>Available Credits:</strong> 
                    <Badge bg="success" className="fs-6 ms-2">
                      {profile?.deals_wallet_credits || 0}
                    </Badge>
                  </div>
                  <div className="mb-2">
                    <strong>Credits After Enrichment:</strong> 
                    <Badge 
                      bg={hasInsufficientCredits ? "danger" : "info"} 
                      className="fs-6 ms-2"
                    >
                      {(profile?.deals_wallet_credits || 0) - totalCost}
                    </Badge>
                  </div>
                  {hasInsufficientCredits && (
                    <div className="text-danger">
                      <small>
                        <i className="fas fa-exclamation-triangle me-1"></i>
                        Insufficient credits available
                      </small>
                    </div>
                  )}
                </div>
              </Col>
            )}
          </Row>
        </div>

        {!hasActiveSubscription && hasInsufficientCredits && (
          <div className="alert alert-warning mb-0">
            <h6 className="alert-heading">
              <i className="fas fa-credit-card me-2"></i>Insufficient Credits!
            </h6>
            <p className="mb-0">
              You need <strong>{totalCost - (profile?.deals_wallet_credits || 0)} more credits</strong> to complete this enrichment.
              <br />
              <small className="text-muted">Click "Buy More Credits" to purchase additional credits.</small>
            </p>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        {!hasActiveSubscription && hasInsufficientCredits ? (
          <Button 
            variant="warning" 
            onClick={onBuyCredits}
          >
            <i className="fas fa-shopping-cart me-2"></i>
            Buy More Credits
          </Button>
        ) : (
          <Button 
            variant="primary" 
            onClick={onConfirm}
            disabled={enrichLoading}
          >
            {enrichLoading ? (
              <>
                <Spinner /> Processing...
              </>
            ) : (
              <>
                <i className="fas fa-check me-2"></i>
                {hasActiveSubscription
                  ? "Confirm Enrichment"
                  : `Confirm Enrichment (${totalCost} credits)`}
              </>
            )}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default EnrichmentConfirmationModal; 